import { z } from 'zod';
/**
 * A person's own notifications (§17.2, slice-02 session 6).
 *
 * Shared by the console and the caregiver PWA: both call
 * `GET /v1/notifications`, and each person only ever sees rows addressed to
 * them. The text is written server-side for the reader it is addressed to — a
 * caregiver reads "Your CPR certification…", HR reads "Maria Lopez's CPR
 * certification…" — so neither client composes a sentence from codes.
 */
export const notificationKindSchema = z.enum(['CREDENTIAL_EXPIRING', 'CREDENTIAL_EXPIRED']);
/**
 * What the notification is about, and what the reader can do from it.
 *
 * `credentialTypeId` is what makes the caregiver's upload direct: the field app
 * opens the upload form already set to the credential being renewed, so the
 * caregiver takes a photograph and sends it without choosing anything.
 */
export const credentialNotificationSubjectSchema = z.object({
    type: z.literal('caregiver_credential'),
    credentialId: z.string().uuid(),
    caregiverId: z.string().uuid(),
    credentialTypeId: z.string().uuid(),
    credentialTypeName: z.string(),
    /** The last valid day, inclusive. */
    expiresAt: z.string(),
    /** The threshold this notification names; null for an expiry. */
    thresholdDays: z.number().int().nullable(),
});
export const notificationSchema = z.object({
    id: z.string().uuid(),
    kind: notificationKindSchema,
    title: z.string(),
    body: z.string(),
    subject: credentialNotificationSubjectSchema,
    readAt: z.string().nullable(),
    createdAt: z.string(),
});
export const notificationListSchema = z.object({
    notifications: z.array(notificationSchema),
    unread: z.number().int().nonnegative(),
});
//# sourceMappingURL=notification.js.map